module.exports = __webpack_public_path__ + "img/shadow.f315e442.png";